// ─────────────────────────────────────────────────────────────
//  Shared helpers
// ─────────────────────────────────────────────────────────────

/** Today as YYYY-MM-DD */
export function todayStr() {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,"0")}-${String(n.getDate()).padStart(2,"0")}`;
}

/** Build year levels from units + training plan */
export function buildLevels(units, trainingPlan, yearLabels) {
  const labels = yearLabels || { 1:"Foundation", 2:"Core Systems", 3:"Advanced Diagnostics" };
  const planMap = {};
  (trainingPlan || []).forEach(p => { planMap[p.unit_code] = p.year; });

  const byYear = { 1:[], 2:[], 3:[] };

  (units || []).forEach(u => {
    const yr = Number(planMap[u.code]);
    if (yr >= 1 && yr <= 3) byYear[yr].push(u);
  });

  return [1,2,3].map(yr => ({
    year: yr,
    label: `Year ${yr} — ${labels[yr] || ''}`,
    units: byYear[yr],
  }));
}

/** Parse bullet-point evidence requirements into nested structure */
export function parseEvidenceBullets(raw) {
  if (!raw) return [];
  const lines = raw.split("\n").filter(l => l.trim());
  const items = [];
  let current = null;

  for (const line of lines) {
    const trimmed = line.trimStart();
    if (!trimmed.startsWith("*")) continue;
    const content = trimmed.replace(/^\*\s*/, "").trim();
    const indent = line.search(/\S/);

    if (indent <= 0) {
      current = { text: content, children: [] };
      items.push(current);
    } else if (indent <= 4 && current) {
      const sub = { text: content, children: [] };
      current.children.push(sub);
    } else if (current && current.children.length > 0) {
      const lastChild = current.children[current.children.length - 1];
      lastChild.children.push({ text: content, children: [] });
    }
  }
  return items;
}

/** Extract unit codes from evidence entry (handles both legacy and multi-unit format) */
export function getEntryCodes(entry) {
  try {
    const parsed = JSON.parse(entry.unit_codes || "[]");
    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
  } catch {}
  return entry.unit_code ? [entry.unit_code] : [];
}

/** Does an evidence entry match a given unit code? */
export function entryMatchesUnit(entry, code) {
  return getEntryCodes(entry).includes(code);
}

/** Add 1 calendar year to a date string, return YYYY-MM-DD */
export function addYear(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
}
